
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>快速上手</h1>
<h2>安装</h2>
<p><code>npm i howuse</code></p>
<h2>使用说明</h2>
<p>本库基于 <code>&quot;vue&quot;: &quot;3.2.26&quot;</code>构建，建议使用 vue3 + 版本</p>
<p>文档总体分为扩展区、增删改查、组件</p>
<ul>
<li>扩展区： 是在热门js库的基础上，结合vue语法，易于代码中使用</li>
<li>增删改查： 是在常用UI库的基础上建立快速的CRUD</li>
<li>组件： 开发一些小众的组件、但大多UI不直接支持，在项目有时会用到</li>
</ul>
<p><code>howuse</code> 其它依赖包，具体需要参考如下表格。没有出现在依赖表当中组件不需要安装任何依赖，依赖表中的版本号仅代表开发时的版本，建议使用其依赖之上的版本。</p>
<table>
<thead>
<tr>
<th>包路径</th>
<th>依赖</th>
</tr>
</thead>
<tbody>
<tr>
<td>howuse/axios</td>
<td>“axios”: “^0.25.0”</td>
</tr>
<tr>
<td>howuse/echarts</td>
<td>“echarts”: “^5.3.0”</td>
</tr>
<tr>
<td>howuse/crud/antd</td>
<td>“ant-design-vue”: “^3.2.12”</td>
</tr>
<tr>
<td>howuse/pdf</td>
<td>“jspdf”: “^2.5.1”,“html2canvas”: “^1.4.1”</td>
</tr>
</tbody>
</table>
<h2>注意点</h2>
<p>内置组件均以<code>How</code>作为开头，在代码当中方便辨认</p>
<p>这个库所以示例涉及UI部分，可能使用了第三方UI库，例如：<code>ant-design-vue</code>作为示例，如果使用其它库，复制代码之后，修改对应部分即可。</p>
<p>如有任何问题，可以在这里提问。<a href="https://github.com/biancangming/howuse/issues">https://github.com/biancangming/howuse/issues</a></p>
<h2>功能列表</h2>
<p><a href="https://biancangming.github.io/howuse/#/about">https://biancangming.github.io/howuse/#/about</a></p>
</div>
</template>
